import { HugeiconsIcon, HugeiconsIconProps } from "@hugeicons/react";
import { Radio } from "shared/components";
import { cx } from "shared/utils";

export const OptionLabel = ({
  icon,
  title,
  description,
  selected
}: {
  icon: HugeiconsIconProps["icon"];
  title: string;
  description: string;
  selected: boolean;
}) => (
  <div className="flex gap-4 items-center">
    <div
      className={cx(
        "h-10 w-10 shrink-0 rounded-lg transition-all flex items-center justify-center",
        selected
          ? "bg-primary-50 text-primary-500"
          : "text-content-200 bg-alpha-40"
      )}
    >
      <HugeiconsIcon icon={icon} size={20} />
    </div>

    <div className="space-y-1">
      <p className="text-base text-content-900 font-bold">{title}</p>
      <p className="text-xs text-content-400 font-medium">{description}</p>
    </div>

    <Radio id={title} name={title} checked={selected} className="ml-auto" />
  </div>
);
